import React, { Component } from "react";
import { Link } from 'react-router-dom';
import {  
 Image,
  Dropdown,
  Icon,
  } from "semantic-ui-react";
  // import {data1} from "./Data"
class Navbar extends Component {
  state = {
    display:'none',
  };

 //^^^^^^^^^^^^^^^
toggleDisplayLeft = ()=>{
  this.setState({ openLeft: !this.state.openLeft });
}

// @@@@@
 renderShowHideSidebarButtonLeft =()=>{
  return this.state.openLeft === true ? ( 
    <>
    <div className="buttonSide"
    // style={{fontSize:'18px',height:'30px',color:'white'}}  
    onClick={ this.toggleDisplayLeft }

    ><Icon name="close" /></div></>
  ) : (
    <>
    <button  className="buttonSide"
    // style={{fontSize:'18px',height:'30px',color:'white'}}
    onClick={ this.toggleDisplayLeft }

    ><Icon name="sidebar" /></button></>
    )}
//****************** */

  render() {
    
  

//  NAV DESKTOP
 
    const authLinks = (
      <nav id="navbar-desktop" className="font-family-Roboto" style={{ flexDirection: "row" }}>
        <div style={{ display: "flex" }}>
          <div style={{ display: "flex", alignItems: "center" }}>
            <Image
              className=" border-logo"
              size="small"
              src="/logo.png"
              style={{ marginRight: ".5em" }}
            />
            <div>
         {this.props.userA !== null && (this.props.userA.userType === 'admin' ||this.props.userA.userType === 'manager_ggn') && this.renderShowHideSidebarButtonLeft()} 
        

        <div 
        className={this.state.openLeft 
          ? "menu-left-wrapper menu-left-open "
          : "menu-left-wrapper  "}
           >
        <div 
        onClick={this.toggleDisplayLeft}
        style={{width:'300px'}} 
        className="card font-16B color-white bgColor-CornflowerBlue flex-center border-radius-05"
        >

{/*  */}
<div className="dividerGr"></div>
<div className="py-05"
onClick={() =>this.props.openModal("CreateFormModal",{propresi_Ggn:true})}
>
<span className="link-gr cursor-pointer" >Create Residential Property</span>
</div>

<div className="dividerGr"></div>

<div className="py-05"
onClick={() =>this.props.openModal("CreateFormModal",{propcom_Ggn:true})}
>
<span className="link-gr cursor-pointer" >Create Commercial Property</span>
</div>
<div className="dividerGr"></div>

{/*  */}
<div className="py-05"
onClick={() =>this.props.openModal("CreateFormNameModal",{locality_Ggn:true})}
>
<span className="link-gr cursor-pointer" >Create Locality</span>
</div>
<div className="dividerGr"></div>

<div className="py-05"
onClick={() =>this.props.openModal("CreateFormNameModal",{projResi_Ggn:true})}
>
<span className="link-gr cursor-pointer" >Create Residential Project Name</span>
</div>
<div className="dividerGr"></div>

<div className="py-05"
onClick={() =>this.props.openModal("CreateFormNameModal",{projCom_Ggn:true})}
>
<span className="link-gr cursor-pointer" >Create Commercial Project Name</span>
</div>
<div className="dividerGr"></div>

{/*  */}
<div className="py-05"
onClick={() =>this.props.openModal("ViewNameModal",{locality_Ggn:true})}
>
<span className="link-gr cursor-pointer" >View Locality</span>
</div>
<div className="dividerGr"></div>

<div className="py-05"
onClick={() =>this.props.openModal("ViewNameModal",{projResi_Ggn:true})}
>
<span className="link-gr cursor-pointer" >View Residential Project Name</span>
</div>
<div className="dividerGr"></div>

<div className="py-05"
onClick={() =>this.props.openModal("ViewNameModal",{projCom_Ggn:true})}
>
<span className="link-gr cursor-pointer" >View Commercial Project Name</span>
</div>
<div className="dividerGr"></div>

</div>
</div>
</div>
{/*  */}
          </div>
        </div>

        <ul>
          <br />

          <span>
            <li className="px-0">
              <Link className="link-gr" to="/"><Icon><i className="home icon"></i></Icon></Link>
              {/* <a href="/">Home</a> */}
            </li>
          </span>
          <span>
            <li className="px-0">
            <Link className="link-gr" to="/ggn/">Dwarka Expressway</Link>
              {/* <a href="/">Home</a> */}
            </li>
          </span>

          <span>
            <li
            // style={{
            //   fontSize: "1.5rem",
            //   fontWeight: "bold",
            //   marginRight: "5px",
            //   padding: "5px",
            //   // color: "blue",
            // }}
            >
              <Dropdown
                style={{ color: "aqua", fontSize: "16px", fontWeight: "bold" }}
                pointing="top right"
                text="For Sale"
                // icon="user outline"
              >
                <Dropdown.Menu>
                  {/*  */}

                  <Dropdown.Item
                    style={{
                      fontWeight: "bold",
                      cursor: "auto",
                      background:
                        "linear-gradient(to bottom right, #4a9cc5, #264982)",
                    }}
                  >
                    <Link className="link-gr" to="/ggn/propresi/PropResiSaleSearchList">Residential</Link>
                   
                  </Dropdown.Item>

                  <Dropdown.Item
                    style={{
                      fontWeight: "bold",
                      cursor: "auto",
                      background:
                        "linear-gradient(to bottom right, #4a9cc5, #264982)",
                    }}
                  >
                    <Link className="link-gr" to="/ggn/propcom/PropComSaleSearchList">Commercial</Link>
                    
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </li>
          </span>

          <span>
            <li
            // style={{
            //   fontSize: "1.5rem",
            //   fontWeight: "bold",
            //   marginRight: "5px",
            //   padding: "5px",
            //   // color: "blue",
            // }}
            >
              <Dropdown
                style={{ color: "aqua", fontSize: "16px", fontWeight: "bold" }}
                pointing="top right"
                text="For Rent"
                // icon="user outline"
              >
                <Dropdown.Menu>
                  {/*  */}

                  <Dropdown.Item
                    style={{
                      fontWeight: "bold",
                      cursor: "auto",
                      background:
                        "linear-gradient(to bottom right, #4a9cc5, #264982)",
                    }}
                  >
                    <Link className="link-gr" to="/ggn/propresi/PropResiRentSearchList">Residential</Link>
                    
                  </Dropdown.Item>

                  <Dropdown.Item
                    style={{
                      fontWeight: "bold",
                      cursor: "auto",
                      background:
                        "linear-gradient(to bottom right, #4a9cc5, #264982)",
                    }}
                  >
                    <Link className="link-gr" to="/ggn/propcom/PropComRentSearchList">Commercial</Link>
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </li>
          </span>
        </ul>
      </nav>
    );



    return (
      <div>
        {
          authLinks
        }
      </div>
    );
  }
}
//@@@@@@@@@@@@@@@@@


export default Navbar;
